/* global axios */
import ApiClient from '../ApiClient';

class DinastiaWhatsappChannel extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getUrl(inboxId, action) {
    return `${this.baseUrl()}/inboxes/${inboxId}/dinastia_whatsapp/${action}`;
  }

  react(inboxId, { messageId, emoji }) {
    return axios.post(this.getUrl(inboxId, 'react'), {
      message_id: messageId,
      emoji,
    });
  }

  editMessage(inboxId, { messageId, content }) {
    return axios.post(this.getUrl(inboxId, 'edit_message'), {
      message_id: messageId,
      content,
    });
  }

  deleteMessage(inboxId, { messageId }) {
    return axios.post(this.getUrl(inboxId, 'delete_message'), {
      message_id: messageId,
    });
  }

  markRead(inboxId, { messageId }) {
    return axios.post(this.getUrl(inboxId, 'mark_read'), {
      message_id: messageId,
    });
  }

  sendTyping(inboxId, { to, duration }) {
    return axios.post(this.getUrl(inboxId, 'typing'), {
      to,
      duration: duration || 3000,
    });
  }

  getQrCode(inboxId) {
    return axios.get(this.getUrl(inboxId, 'qr_code'));
  }

  connect(inboxId) {
    return axios.post(this.getUrl(inboxId, 'connect'));
  }

  disconnect(inboxId) {
    return axios.post(this.getUrl(inboxId, 'disconnect'));
  }

  syncHistory(inboxId) {
    return axios.post(this.getUrl(inboxId, 'history_sync'));
  }

  getSessionStatus(inboxId) {
    return axios.get(this.getUrl(inboxId, 'session_status'));
  }
}

export default new DinastiaWhatsappChannel();
